module.exports = __webpack_public_path__ + "img/idigi-surveynet.a5579a76.png";